import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from 'components/commons/Input';

import './TermsAcceptance.scss';

const TermsAcceptance = ({ terms }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [isOpen]);

  if (!terms?.document_url) return null;

  return (
    <div className="terms-acceptance" data-testid="terms-acceptance">
      <Field
        component={Input}
        inputClassName="terms-acceptance__checkbox"
        label={`Acepto ${terms.title}`}
        name="accept_terms"
        type="checkbox"
      />
      <button
        className="terms-acceptance__link"
        type="button"
        onClick={() => setIsOpen(true)}
      >
        Ver términos y condiciones
      </button>

      {isOpen && (
        <div
          className="terms-modal__backdrop"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setIsOpen(false);
          }}
        >
          <section
            aria-labelledby="terms-modal-title"
            aria-modal="true"
            className="terms-modal"
            role="dialog"
          >
            <header className="terms-modal__header">
              <h2 id="terms-modal-title">{terms.title}</h2>
              <button
                aria-label="Cerrar términos y condiciones"
                className="terms-modal__close"
                type="button"
                onClick={() => setIsOpen(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </header>
            <iframe
              className="terms-modal__document"
              src={terms.document_url}
              title={terms.title}
            />
            <footer className="terms-modal__footer">
              <a href={terms.document_url} rel="noopener noreferrer" target="_blank">
                Abrir PDF en otra pestaña
              </a>
              <button className="btn btn-primary" type="button" onClick={() => setIsOpen(false)}>
                Cerrar
              </button>
            </footer>
          </section>
        </div>
      )}
    </div>
  );
};

TermsAcceptance.propTypes = {
  terms: PropTypes.shape({
    title: PropTypes.string.isRequired,
    document_url: PropTypes.string.isRequired,
  }),
};

export default TermsAcceptance;
